'use client';

import type { PremiseStatusV2 } from '@dte/otw-azure-functions/src/common/interfaces/api/PremiseStatusV2';
import { copyJson } from '@dte/otw-utils-core/src/objects/copyJson';
import { useState } from 'react';
import { MessageDetailDisplay } from '../../../../../../components/SearchPremises/MessageDetailDisplay';
import { Spinner } from '../../../../../../components/Spinner/Spinner';
import { AuthenticatedJsonContent } from '../../../content/jsonGet/AuthenticatedJsonContent';
import { type PropsWithPremiseId, usePremiseId } from '../usePremiseId';
import { getPremiseStatusURL } from './getPremiseStatusURL';
import { PremiseSectionHeader } from './PremiseSectionHeader';

export function PremiseStatusDisplayContent({ status }: { status?: PremiseStatusV2 }) {
	// Omit details from displaying (longer text is only used for IVR)
	const causeDetails = copyJson(status?.cause);
	delete causeDetails?.details;

	if (!status) {
		return <Spinner />;
	}

	return (
		<section style={{ marginTop: '1rem', minHeight: '10rem' }}>
			<PremiseSectionHeader>Status displayed in self-service channels</PremiseSectionHeader>
			<MessageDetailDisplay messageDetail={status?.status}>Status</MessageDetailDisplay>
			<MessageDetailDisplay messageDetail={status?.estimate}>Estimated Restoration</MessageDetailDisplay>
			<MessageDetailDisplay messageDetail={causeDetails}>Cause</MessageDetailDisplay>
		</section>
	);
}

export function PremiseStatusDisplay({ premiseId }: PropsWithPremiseId) {
	const premiseIdValue = usePremiseId(premiseId);
	const url = getPremiseStatusURL(premiseIdValue);

	const [status, setStatus] = useState<PremiseStatusV2>();

	return (
		<>
			<PremiseStatusDisplayContent status={status} />
			<AuthenticatedJsonContent url={url} setData={setStatus} />
		</>
	);
}
